import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "fv-row mb-7" }
const _hoisted_6 = { class: "nav nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-0 fs-4 fw-semobold mb-8" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "tab-content" }

import { ref } from "vue";
import accountInfo from "@/projects/tenant/views/accountOverview/components/accountDetail/accountInfo.vue";
import TradeHistory from "@/projects/tenant/views/accountOverview/components/accountDetail/accountTrade.vue";
import accountTransfer from "@/projects/tenant/views/accountOverview/components/accountDetail/accountTransfer.vue";
import accountDeposit from "@/projects/tenant/views/accountOverview/components/accountDetail/acccountDeposit.vue";
import accountWithdrawal from "./accountDetail/accountWithdrawal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetail',
  props: {
  account: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const tabs = ref([
  {
    name: "Info",
    component: "accountInfo",
    id: 1,
  },
  {
    name: "Trade",
    component: "TradeHistory",
    id: 2,
  },
  {
    name: "Transfer",
    component: "accountTransfer",
    id: 3,
  },
  {
    name: "Deposit",
    component: "accountDeposit",
    id: 4,
  },
  {
    name: "Withdrawal",
    component: "accountWithdrawal",
    id: 5,
  },
]);
const componentMap = {
  accountInfo,
  TradeHistory,
  accountTransfer,
  accountDeposit,
  accountWithdrawal,
};
const currentTab = ref(1);

const handleTabs = (id: number) => {
  currentTab.value = id;
};
const isTabActive = (tab: number) => {
  return tab === tabs.value[0].id;
};
const getComponent = (componentName: string) => {
  return componentMap[componentName];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$props.account.user.email) + " / " + _toDisplayString(props.account.accountNumber), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "nav-item",
              key: tab.id
            }, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link text-active-primary pb-4", { active: isTabActive(tab.id) }]),
                "data-bs-toggle": "tab",
                href: "#",
                onClick: ($event: any) => (handleTabs(tab.id))
              }, _toDisplayString(tab.name), 11, _hoisted_7)
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabs.value, (tab) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: tab.id
          }, [
            (currentTab.value === tab.id)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(getComponent(tab.component)), {
                  key: 0,
                  account: props.account
                }, null, 8, ["account"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ]))
}
}

})